import * as React from 'react';
import { Provider } from 'react-redux';

import { middleware as idleMiddleware } from './js/utils/reduxIdleMonitor';
import { actions as idleActions } from './js/utils/reduxIdleMonitor';

import {
    applyMiddleware,
    /* combineReducers, */
    compose,
    createStore,
} from 'redux';

import reducers from './js/reducers';

// declare var reducers: any;

// import createLogger from 'redux-logger';
import * as promise from 'redux-promise';
import thunk from 'redux-thunk';
import { types } from './js/actions/types';

const rootReducer = (state, action) => {
    if (action.type === types.LOG_OUT_SUCCESS) state = undefined;
    return reducers(state, action)
}

let currentUserIsAuthorized = false;

declare global {
    interface Window { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any; }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
// const logger = createLogger();

export default ({ children, initialState = {} }) => {
    const store = createStore(
        rootReducer,
        {},
        composeEnhancers(
            applyMiddleware(thunk, idleMiddleware, promise/*, logger */)
        ),

    );


    store.subscribe(() => {
        const previousUserIsAuthorized = currentUserIsAuthorized;

        const state = store.getState();

        // DETERMINE IF USER IS AUTHORIZED
        currentUserIsAuthorized = state && state.auth.authData && !!state.auth.authData.id

        // IF THE USER IS NOW AUTHORIZED TURN ON IDLE MONITOR, OTHERWISE TURN IT OFF
        if (currentUserIsAuthorized !== previousUserIsAuthorized) {
            store.dispatch((currentUserIsAuthorized ? idleActions.start : idleActions.stop)());
        }
    })

    return (
        <Provider store={ store }>
            { children }
        </Provider>
    )
}


// WEBPACK FOOTER //
// ./src/StoreProvider.tsx